module.exports = __webpack_public_path__ + "static/img/banner-6.2cf2f31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner-6.png
// module id = Pl2W
// module chunks = 1